<template>
  <v-dialog
    width="300"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        depressed
        color="accent"
        :disabled="$store.state.loading"
        :loading="$store.state.loading"
        v-on="on"
      >
        Sign in
      </v-btn>
    </template>

    <v-card color="primary">
      <v-card-title class="justify-center white--text">
        Sign in with
      </v-card-title>

      <v-card-text>
        <div>
          <v-btn
            color="white"
            block
            @click="signInWithGoogle()"
          >
            <v-icon left>
              mdi-google
            </v-icon>
            Google
          </v-btn>
        </div>

        <div class="mt-4">
          <v-btn
            color="#4267B2"
            dark
            block
            @click="signInWithFacebook()"
          >
            <v-icon left>
              mdi-facebook-box
            </v-icon>
            Facebook
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import * as firebase from 'firebase/app'

export default {
  methods: {
    signInWithFacebook () {
      const provider = new firebase.auth.FacebookAuthProvider()
      provider.setCustomParameters({
        'display': 'popup'
      })

      this.signIn(provider)
    },
    signInWithGoogle () {
      this.signIn(new firebase.auth.GoogleAuthProvider())
    },
    async signIn (provider) {
      try {
        await firebase.auth().signInWithPopup(provider)
        this.$router.push({ name: 'trips' })
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style>

</style>
